<template>
  <div
    class="tag"
    :class="{
      white,
      'with-button': deleteOption,
    }"
  >
    <span class="text-medium">{{ tagName }}</span>
    <button
      v-if="deleteOption"
      class="button flex-vcenter"
      @click="$emit('delete-tag')"
    >
      <IconTrashReset height="12" />
    </button>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import IconTrashReset from "../../components/icons/IconTrashReset.vue";

/**
 * Affiche un tag avec la possibilité de le supprimer.
 */
export default defineComponent({
  name: "FilterTag",
  components: {
    IconTrashReset,
  },
  props: {
    /**
     * Nom du tag.
     */
    tagName: {
      type: String,
      default: "",
    },
    /**
     * Change la couleur en blanc.
     */
    white: {
      type: Boolean,
      default: false,
    },
    /**
     * Permet d'ajouter un bouton de suppression du tag.
     */
    deleteOption: {
      type: Boolean,
      defaut: false,
    },
  },
  emits: [
    /**
     * Déclenché au clic sur le bouton de suppression.
     */
    "delete-tag",
  ],
});
</script>

<style lang="scss">
@use "../../assets/styles/components/infos/tag.scss";
</style>
